import { memo } from "react";
import type { TextFieldProps } from "@mui/material";
import NumberFormat from "react-number-format";
import type { NumberFormatProps } from "react-number-format";
import useNumberSeparators from "hooks/useNumberSeparators";
import TextField from "../TextField";
import useDecimalSeparatorPaste from "./hooks/useDecimalSeparatorPaste";

type Base = Omit<
  NumberFormatProps<TextFieldProps>,
  "thousandSeparator" | "decimalSeparator" | "allowedDecimalSeparators"
>;

export type NumberInputProps = Base & {
  grouping?: boolean;
};

function NumberInput(props: NumberInputProps) {
  const { grouping, onPaste, ...rest } = props;
  const separators = useNumberSeparators({ grouping });
  const handlePaste = useDecimalSeparatorPaste({ ...separators, onPaste });

  return (
    <NumberFormat customInput={TextField} isNumericString fullWidth {...rest} {...separators} onPaste={handlePaste} />
  );
}

export default memo(NumberInput);
